import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1, // 10% of transactions for performance monitoring
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    
    // Filter sensitive data
    beforeSend(event) {
      // Remove phone numbers and emails from error messages
      if (event.message) {
        event.message = event.message.replace(/\d{10}/g, '**PHONE**');
        event.message = event.message.replace(/[\w.-]+@[\w.-]+\.\w+/gi, '**EMAIL**');
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
